import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
    addSwatchButton: {
        height: '15px',
        width: '15px',
        minWidth: '15px',
        borderRadius: '2px',
        padding: 0,
        '& svg': {
            height: '20px',
            width: '20px'
        }
    },
}))

export default useStyles